/**
 * Адаптер для преобразования дат "из" и "в" формат для API.
 * @type {{fromRussian(*): string, toRussian(*): (string|*)}}
 */
const ApiDateAdapter = {
  fromRussian(date) {
    if (null === date) {
      return null;
    }

    return date.split('.').reverse().join('-');
  },
  toRussian(date) {
    if (null === date) {
      return null;
    }

    return date.split('-').reverse().join('.');
  },
};

export {ApiDateAdapter};